import * as React from 'react';
var TabsContext = /*#__PURE__*/React.createContext(null);
export var TabsContextProvider = TabsContext.Provider;
export default TabsContext;